/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  today: 'à®à®©à¯à®±à¯',
  now: 'à®à®ªà¯à®ªà¯à®¤à¯',
  backToToday: 'à®à®©à¯à®±à¯à®à¯à®à¯ à®¤à®¿à®°à¯à®®à¯à®ªà¯',
  ok: 'à®à®°à®¿',
  clear: 'à®à®´à®¿',
  month: 'à®®à®¾à®¤à®®à¯',
  year: 'à®µà®°à¯à®à®®à¯',
  timeSelect: 'à®¨à¯à®°à®¤à¯à®¤à¯à®¤à¯ à®¤à¯à®°à¯à®¨à¯à®¤à¯à®à¯',
  dateSelect: 'à®¤à¯à®¤à®¿à®¯à¯à®¤à¯ à®¤à¯à®°à¯à®¨à¯à®¤à¯à®à¯',
  weekSelect: 'à®µà®¾à®°à®¤à¯à®¤à¯à®¤à¯ à®¤à¯à®°à¯à®µà¯à®à¯à®¯à¯à®',
  monthSelect: 'à®®à®¾à®¤à®¤à¯à®¤à¯à®¤à¯ à®¤à¯à®°à¯à®µà¯à®à¯à®¯à¯à®',
  yearSelect: 'à®µà®°à¯à®à®¤à¯à®¤à¯à®¤à¯ à®¤à¯à®°à¯à®µà¯à®à¯à®¯à¯à®',
  decadeSelect: 'à®¤à®à®¾à®ªà¯à®¤à®¤à¯à®¤à¯à®¤à¯ à®¤à¯à®°à¯à®µà¯à®à¯à®¯à¯à®',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'à®®à¯à®¨à¯à®¤à¯à®¯ à®®à®¾à®¤à®®à¯ (PageUp)',
  nextMonth: 'à®à®à¯à®¤à¯à®¤ à®®à®¾à®¤à®®à¯ (PageDown)',
  previousYear: 'à®®à¯à®¨à¯à®¤à¯à®¯ à®µà®°à¯à®à®®à¯ (Control + left)',
  nextYear: 'à®à®à¯à®¤à¯à®¤ à®µà®°à¯à®à®®à¯ (Control + right)',
  previousDecade: 'à®®à¯à®¨à¯à®¤à¯à®¯ à®¤à®à®¾à®ªà¯à®¤à®®à¯',
  nextDecade: 'à®à®à¯à®¤à¯à®¤ à®¤à®à®¾à®ªà¯à®¤à®®à¯',
  previousCentury: 'à®®à¯à®¨à¯à®¤à¯à®¯ à®¨à¯à®±à¯à®±à®¾à®£à¯à®à¯',
  nextCentury: 'à®à®à¯à®¤à¯à®¤ à®¨à¯à®±à¯à®±à®¾à®£à¯à®à¯'
};
